export default function () {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

    cardWidgetLoaded: function (data) {
      checkData(data, widgetName);
    },

    buyNowButton: false,
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [''],
    maxItemsVisible: 1,
    moreButton: false,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true,
  });
}

function checkData(data, widgetName) {
  const widgetCount = data.items.length;
  if (widgetCount == 0) {
    $(`#${widgetName}`).remove();
  } else {
    createSeo(data, widgetName);
  }
}

function createSeo(data, widgetName) {
  const { Title, Description } = data.items[0];

  $(`#${widgetName}`).find('.card-widget-title')
    .replaceWith(`<h1 class="card-widget-title" aria-label="${Title}">         
        ${Title}
      </h1>`);

  if (!Description || Description.trim() === '') {
    $(`#${widgetName}`).find('.card-widget-description').remove();
  }
}
